import { defineMessages } from "react-intl";

const messages = defineMessages({
  drafts: {
    id: "email.creation.draftsButton.drafts",
    defaultMessage: "Drafts",
    description: "Manage email drafts button - Drafts",
  },
  draftSaveErrorDescription: {
    id: "email.creation.draftsButton.draftSaveErrorDescription",
    defaultMessage: "Please try again or contact support.",
    description: "Manage email drafts button - Draft save error message",
  },
  draftSaveErrorMessage: {
    id: "email.creation.draftsButton.draftSaveErrorMessage",
    defaultMessage: "Error saving draft",
    description: "Manage email drafts button - Draft save error message",
  },
  draftSaveSuccessMessage: {
    id: "email.creation.draftsButton.draftSaveSuccessMessage",
    defaultMessage: "Draft saved",
    description: "Manage email drafts button - Draft save success message",
  },
  mostRecent: {
    id: "email.creation.draftsButton.mostRecent",
    defaultMessage: "Most Recent",
    description: "Manage email drafts button - Most Recent",
  },
  noSubject: {
    id: "email.creation.draftsButton.noSubject",
    defaultMessage: "(No Subject)",
    description: "Manage email drafts button - No subject",
  },
  saveAsDraft: {
    id: "email.creation.draftsButton.saveAsDraft",
    defaultMessage: "Save as Draft",
    description: "Manage email drafts button - Save as Draft",
  },
  seeMore: {
    id: "email.creation.draftsButton.seeMore",
    defaultMessage: "More Drafts",
    description: "Manage email drafts button - See More",
  },
});

export default messages;
